import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { ActivatedRoute, Router } from "@angular/router";
import { concat } from 'rxjs/operator/concat';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-complaints-list',
    templateUrl: './complaints-list.component.html',
    styleUrls: ['./complaints-list.component.scss']
})
export class ComplaintsListComponent implements OnInit, OnDestroy {

    rows: any[];
    loadingIndicator = true;
    reorderable = true;
    queryString: any;
    length: any;
    private sub: any;
    post: any;

    constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router, private afs: AngularFirestore) {

    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            this.queryString = this.route.snapshot.queryParams['name'];

            this.sub = this.afs.collection('complaints').doc(this.queryString).collection('users')
                .valueChanges()
                .subscribe((res: any) => {
                    console.log(res, "res")
                    console.log(this.length, "length")
                    this.rows = res;
                    this.length = res.length;
                    this.loadingIndicator = false;
                });


        });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/user-complaints/complaints-list/complaints-list.component.ts